<template>
  <component
    :is="getCustomFieldType(customProp.type)"
    v-model="vModel"
    :label="customProp.name"
    :items="customProp.values"
    :hint="customProp.description"
    persistent-hint
  />
</template>

<script>
import { VSwitch, VSelect, VTextField } from 'vuetify/lib'

const CUSTOM_FIELDS_BY_TYPE = {
  boolean: 'v-switch',
  enum: 'v-select',
  number: 'v-text-field',
  string: 'v-text-field'
}

export default {
  components: {
    VSwitch,
    VSelect,
    VTextField
  },
  props: {
    customProp: {
      type: Object,
      required: true
    },
    value: {
      type: [Boolean, String],
      default: null
    }
  },
  computed: {
    vModel: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  methods: {
    getCustomFieldType (type) {
      return CUSTOM_FIELDS_BY_TYPE[type]
    }
  }
}
</script>

<style>

</style>
